<template>
  <section
    :class="{
      'section-builder-designer-cards': true,
    }"
  >
    <GeneralTheme
      :theme="configuration"
      :style="{
        backgroundSize: '100%',
        backgroundPosition: 'top left',
      }"
    >
      <div
        :class="{
          'designer-cards pt-36': true,
          'text-www-color-neutral-medium-dark': true,
        }"
      >
        <div
          :class="{
            container: true,
          }"
        >
          <DesignerCards
            v-if="cards"
            v-bind="cards"
          />
        </div>
      </div>
    </GeneralTheme>
  </section>
</template>
<script setup lang="ts">
import DesignerCards from './DesignerCards.vue';
import type { SectionBuilderDesignerCards } from '~/sanity/types';
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
defineProps<SectionBuilderDesignerCards>();
</script>

<style lang="scss" scoped></style>
